import EmployeeJobScheduleModel from "@/models/EmployeeJobScheduleModel";
import axiosHelper from "../axiosHelper";
import TimelineItemModel from "@/components/timeline/models/TimelineItemModel";
import dateOnlyHelper from "../dateOnlyHelper";
import timeOnlyHelper from "../timeOnlyHelper";

export default class EmployeesJobsScheduleApiHelper {

	_url: string = '/api/employeesJobsSchedule';

	// async autoSchedule(orderId: number, scheduledStartDate: Date, orderJobs: , jwt: string): Promise<Array<EmployeeJobScheduleModel>> {
	// 	try {
	// 		const getManagersHttpClient = axiosHelper.createInstance(jwt);
	// 		const response = await getManagersHttpClient.put(`${this._url}/auto`, {
	// 			id: orderId,
	// 			scheduledStartDateUtc: scheduledStartDate,
	// 			jobs: orderJobsDto,
	// 			executiveEntityBranch: new LegalEntityBranchModel({id: order.executiveEntityBranch!.id })
	// 		});

	// 		if (!response.data?.length) {
	// 			return [];
	// 		}
			
	// 		return this.mapGetScheduleResponse(response.data);
	// 	} catch (e: any) {
	// 		console.error('Error loading jobs schedule', e);
	// 		return [];
	// 	}
	// }

	async getJobsSchedule(branchId: number, date: string, jwt: string): Promise<Array<EmployeeJobScheduleModel>> {
		try {
			const getManagersHttpClient = axiosHelper.createInstance(jwt);
			const response = await getManagersHttpClient.get(`${this._url}/${branchId}/${date}`);
			if (!response.data?.length) {
				return [];
			}
			
			return this.mapGetScheduleResponse(response.data);
		} catch (e: any) {
			console.error('Error loading jobs schedule', e);
			return [];
		}
	}

	async getNonWorkingHours(branchId: number, jwt: string): Promise<Array<TimelineItemModel>> {
		try {
			const getManagersHttpClient = axiosHelper.createInstance(jwt);
			const response = await getManagersHttpClient.get(`${this._url}/nonworkinghours/${branchId}`);
			if (!response.data?.length) {
				return [];
			}
			return response.data.map((_: any) => new TimelineItemModel(_));
		} catch (e: any) {
			console.error('Error loading non-working hours schedule', e);
			return [];
		}
	}

	async saveJobSchedule(
			orderJobId: number,
			startDate: string, 
			startTime: string, 
			endDate: string,
			endTime: string,
			jwt: string): Promise<boolean> {
		try {
			const jobScheduleRequest = this.mapSaveScheduleRequest(orderJobId, startDate, startTime, endTime, endDate);
			const getManagersHttpClient = axiosHelper.createInstance(jwt);
			const response = await getManagersHttpClient.put(`${this._url}/save`, jobScheduleRequest);			
			if (response?.status !== 200) {
				console.error(`Error saving schedule for order job assignee #${orderJobId}: unexpected response status`, response);
				return false;
			}

			return true;
		} catch (e: any) {
			console.error(`Error saving schedule for order job assignee #${orderJobId}:`, e);
			return false;
		}
	}

	private mapSaveScheduleRequest(orderJobAssigneeId: number, startDate: string, startTime: string, endTime: string, endDate: string) {
		const startDateUtc = dateOnlyHelper.toUtcDate(startDate, startTime);
		const startTimeUtc = timeOnlyHelper.toUtcTime(startDate, startTime);

		const endDateUtc = dateOnlyHelper.toUtcDate(endDate, endTime);
		const endTimeUtc = timeOnlyHelper.toUtcTime(endDate, endTime);

		return {
			assigneeId: orderJobAssigneeId,
			startDateUtc,
			startTimeUtc,
			endTimeUtc,
			endDateUtc,
		};
	}

	private mapGetScheduleResponse(jobsSchedule: any[]): Array<EmployeeJobScheduleModel> {
		const offsetMilliseconds = new Date().getTimezoneOffset() * 60 * 1000;

		const mapped = jobsSchedule.map(_ => {
			const employeeJobSchedule = new EmployeeJobScheduleModel(_);

			if (employeeJobSchedule.scheduledDate &&
				employeeJobSchedule.scheduledStartTime &&
				employeeJobSchedule.scheduledEndTime) {

				const startDateTime = this.toDate(employeeJobSchedule.scheduledDate, employeeJobSchedule.scheduledStartTime);
				const endDateTime = this.toDate(employeeJobSchedule.scheduledEndDate, employeeJobSchedule.scheduledEndTime);
		
				const localStartDateTime = new Date(startDateTime.getTime() - offsetMilliseconds);
				const localEndTDateTime = new Date(endDateTime.getTime() - offsetMilliseconds);
		
				employeeJobSchedule.scheduledDate = dateOnlyHelper.date(localStartDateTime);
				employeeJobSchedule.scheduledStartTime = timeOnlyHelper.time(localStartDateTime);
				employeeJobSchedule.scheduledEndTime = timeOnlyHelper.time(localEndTDateTime);
				employeeJobSchedule.scheduledEndDate = dateOnlyHelper.date(localEndTDateTime);
			}

			return employeeJobSchedule;
		});

		return mapped;
	}

	private toDate(dateOnly: string, timeOnly: string) : Date {
		/* dateOnly example: '2025-12-31' */
		/* timeOnly example: '10:30:59' */
		const dateSplitter = '-', timeSplitter = ':';
		
		const [year, month, date] = dateOnly.split(dateSplitter).map(Number);
		const [hour, minute, second] = timeOnly.split(timeSplitter).map(Number);

		return new Date(year, month-1, date, hour, minute, second);
	}
}